import styles from './seat-location.module.css';

export type SeatLocationProps = {
  icon: string;
  number: number;
  className?: string;
};
export const SeatLocation = ({ icon, number }: SeatLocationProps) => {
  return (
    <span className={styles.root}>
      <img src={icon} aria-hidden="true" />
      <span>{number}</span>
    </span>
  );
};
